import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { customElement as e } from '../../../../../node_modules/@lit/reactive-element/decorators/custom-element.js';
import { property as n } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './primary-cta.scss.js';

let PrimaryCta = class PrimaryCta extends s {
    constructor() {
        super(...arguments);
        this.label = 'Log in';
        this.type = 'button';
        this.disabled = false;
        this.href = '';
    }
    handleClick() {
        if (this.href && !this.disabled) {
            window.location.href = this.href;
        }
    }
    render() {
        return x `<button class="primary-cta" type="${this.type}" ?disabled="${this.disabled}" @click="${this.handleClick}"><span>${this.label}</span></button>`;
    }
};
PrimaryCta.styles = css_248z;
__decorate([
    n({ type: String })
], PrimaryCta.prototype, "label", void 0);
__decorate([
    n({ type: String })
], PrimaryCta.prototype, "type", void 0);
__decorate([
    n({ type: Boolean, reflect: true })
], PrimaryCta.prototype, "disabled", void 0);
__decorate([
    n({ type: String })
], PrimaryCta.prototype, "href", void 0);
PrimaryCta = __decorate([
    e('primary-cta')
], PrimaryCta);

export { PrimaryCta };
